var exports = {
  "Z": "x804f0401--7ada42--layout",
};

module.exports = exports;
